const throttle = require('throttle-debounce/throttle');
import CreateImageInstance from './CreateImageInstance';

const LazyLoad = function(){
    let images = [];
    let test = [];
    let win;
    const delays = [0, 200, 400, 600, 800];
    
    const _init = function(){
        images = document.getElementsByClassName('lazy-load');
        images = Array.prototype.slice.call(images);
        win = window;
        loadImage();
        
        win.addEventListener('scroll', throttle(50, handleScroll));
        win.addEventListener('touchmove', throttle(50, handleScroll));
    };

    const loadImage = function(){
        for (let i = images.length - 1; i >= 0; i--) {
            const el = images[i];

            // if (el.dataset.src === undefined && el.dataset.delay === undefined) {
            //     addRandomDelay(el);
            // }

            if (isInView(el)) {
                new CreateImageInstance(el);
                removeItemFromArray(el);
            }
        }
    }

    // const addRandomDelay = function(el){
    //     const randomDelay = delays[Math.floor(Math.random() * delays.length)];
    //     el.dataset.delay = randomDelay;
    //     return el;
    // };

    const removeItemFromArray = function(el){
        const i = images.indexOf(el);
        if (i > -1) {
            images.splice(i, 1);
        }
    }

    const handleScroll = function(e){
        loadImage();
    };

    const isInView = function(el){
        const rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 && 
            rect.bottom <= (win.innerHeight + el.clientHeight || document.documentElement.clientHeight + el.clientHeight)
        );
    };

    return{ 
        init: _init
    };

}();

if (document.getElementsByClassName('lazy-load').length) {
    LazyLoad.init();
}



// WEBPACK FOOTER //
// ./resources/js/partials/LazyLoad.js